<script>
  import Container from '../components/Container.svelte'
  import Block from '../components/Block.svelte'
  import Modal, {ModalHandler} from '../components/Modal.svelte'
  import Form from '../partials/Form.svelte'
  
  export let modalMsgHandler = new ModalHandler(false)
	export let modalMsgStore = modalMsgHandler.store()
</script>

<Modal
  columns={1}
  spacingContainer={30}
  store={modalMsgStore}
  handler={modalMsgHandler}
/>
<!-- <div on:click={() => msg()}>MODAL</div> -->

<main class="shadow">
  <section class="top">
    <h1>
      4º Encontrinho BIC Soleil
    </h1>
  </section>
  <section class="intro">
    <h2>
      Está chegando o 4º encontrinho BIC Soleil
    </h2>
    <p style="max-width: 520px;">
      Neste ano, a edição volta a ser presencial e vai contar com um bate-papo super descontraído entre as embaixadoras de <strong class="highlight">BIC Soleil!</strong>
    </p>
    <p style="max-width: 590px;">
	    Preparamos um conteúdo super inspirador: uma roda de conversa especial com a <strong class="highlight"><a href="https://www.instagram.com/jeskagrecco/" target="_blank">Jeska Grecco</a></strong>, <strong class="highlight"><a href="https://www.instagram.com/rayneon/" target="_blank">Raissa Galvão</a></strong> e <strong class="highlight"><a href="https://www.instagram.com/biaoliveira_/" target="_blank">Bia Oliveira</a></strong>, que abordará temas como <strong>autoestima, bem estar, protagonismo feminino, relação com o corpo e muito mais!</strong>
    </p>
    <p>
      <a href="https://www.youtube.com/watch?v=F9_V_z8TqXo&list=PLk3NxCqxUkj_1Zc2fVjY90TU7JVn8LLwe" target="_blank">
        <img src="/img/btn1.png" alt="Confira como foi a última edição do Encontrinho">
      </a>
    </p>
  </section>
  <section class="produtos">
    <a href="https://www.mundobic.com.br/hotsite/bic-soleil" target="_blank">
      <img src="/img/produtos.png" alt="Conheça toda a linha Bic Soleil">
    </a>
  </section>
  <section class="form">
    <Container
      spacing=36
      style="max-width: 720px; margin: auto;"
    >
      <Block l=50 m=100 style="padding-right: 12px;">
        <h3>
          Curtiu?
        </h3>
        <p>
          <strong class="highlight">Cadastre-se agora</strong>, pois as vagas são limitadas e venha brilhar com a gente!
        </p>
        <p class="endereco">
          <span class="highlight">Local:</span> Casa de Francisca<br>
          <small>Rua Quintino Bocaiúva, 22 - Sé, São Paulo</small><br><br>
          <span class="highlight">Data:</span> 08 de novembro<br><br>
          <span class="highlight">Hora:</span> 14h00
        </p>
        <div class="msg1 _desktop" style="padding-top: 424px;">
          <h3>
            Esperamos Você!
          </h3>
          <div class="insta">
            <a href="https://www.instagram.com/bicbrasiloficial/" target="_blank">
              <img src="/img/instagram.png" alt="Instagram" width="230">
            </a>
          </div>
        </div>
      </Block>
      <Block l=50 m=100>
        <h3>
          Inscreva-se aqui.
        </h3>
        <Form
          {modalMsgHandler}
        />
      </Block>
      <Block l=50 m=100 classes="msg1 _mobile _mobile-centered">
        <h3>
          Esperamos Você!
        </h3>
        <div class="insta">
          <a href="/#">
            <img src="/img/instagram.png" alt="Instagram" width="200">
          </a>
        </div>
      </Block>
    </Container>
  </section>
  <section class="footer">
    <Container
      spacing=36
      style="max-width: 720px; margin: auto;"
    >
      <Block l=100 style="padding-top: 48px; text-align: center;">
        <img src="/img/hashtag.png" alt="#Todas Brilham Com Soleil" width="240">
        <p class="disclaimer">
          * Eventuais custos de deslocamento, hospedagem e alimentação  são de responsabilidade dos inscritos no evento. Ao enviar o formulário, estou ciente da coleta e do armazenamento dos meus dados pessoais pela BIC, e agências de comunicação por ela contratadas, para a finalidade de cadastro e, caso opte por participar, para recebimento de ofertas, comunicados sobre produtos, eventos e novidades da BIC e do Mundo BIC. *Ao enviar meus dados de endereço, estou ciente da coleta e do armazenamento dos meus dados pessoais pela BIC, e empresa de serviços de logística por ela contratada, para a finalidade exclusiva de eventual recebimento de brindes enviados pela BIC. Declaro conhecer a Política de Privacidade do site e Política Geral de Proteção de Dados Pessoais – BIC Brasil (<a href="https://bit.ly/39vlNcM" target="_blank">https://bit.ly/39vlNcM</a>) e ciência do porquê as minhas informações serão utilizadas e de como posso solicitar a exclusão dos meus dados pessoais. Declaro ainda que sou maior de 18 (dezoito) anos de idade ou que represento um indivíduo com idade inferior a 18 (dezoito) anos.
        </p>
      </Block>
    </Container>
  </section>
  <section class="signature">
    <Container
      spacing=36
      style="max-width: 720px; margin: auto;"
    >
      <Block l=100 style="padding-top: 0;">
        <p>
          <span>BIC®</span> / <a href="/politica-de-privacidade" target='_blank'>Política de privacidade</a> / <span>todos os direitos reservados © 2022</span>
        </p>
      </Block>
    </Container>
  </section>
</main>

<style lang="scss">
  @import '../scss/media-sizes';
  .shadow {
    box-shadow: 0px 3px 12px 6px rgba(0,0,0,.2);
  }
  :global(body.sem-fundo .main.outter-container) {
    background-color: #fff;
    max-height: unset;
  }
  :global(.main.outter-container) {
    background-color: #a82664;
    max-height: unset;
  }
  :global(.main .main-content) {
    width: 100%;
    max-width: 1200px;
    padding: 0;
  }
  :global(.msg1._mobile) {
    display: none;
  }
  p {
    color: #fff;
    font-family: 'myriad-pro', sans-serif;
    font-weight: 500;
    font-style: normal;
    font-size: 18px;
    margin: 36px auto;
    text-align: center;
    strong {
      font-family: 'myriad-pro', sans-serif;
      font-weight: 700;
      font-style: normal;
    }
    .highlight {
      color: #000;
    }
  }
  .top {
    height: 64vw;
    max-height: 772px;
    background-size: 100%;
    background-position: top center;
    background-image: url('/img/bgs/0_01.jpg');
    h1 {
      font-size: 0;
    }
  }
  .intro {
    background-size: 100%;
    background-position: top center;
    background-image: url('/img/bgs/0_02.jpg');
    padding-top: 36px;
    padding-bottom: 3px;
    h2 {
      font-size: 0;
      background-image: url('/img/h2.png');
      background-size: contain;
      background-repeat: no-repeat;
      margin: auto;
      width: 400px;
      height: 103px;
    }
    img {
      width: 420px;
    }
  }
  .produtos {
    background-size: 100%;
    background-position: top center;
    background-image: url('/img/bgs/0_03.jpg');
    text-align: center;
    img {
      width: 420px;
    }
  }
  .form {
    background-size: 100%;
    background-position: top center;
    background-image: url('/img/bgs/0_04.jpg');
    p {
      text-align: left;
    }
    h3 {
      font-family: '212LeahleeSans';
      font-size: 42px;
    }
    .endereco {
      font-family: 'myriad-pro', sans-serif;
      font-weight: 700;
      font-style: normal;
      line-height: 1;
    }
    small {
      font-size: 15px;
    }
  }
  .footer {
    background-size: 100%;
    background-position: top center;
    background-image: url('/img/bgs/0_04.jpg');
  }
  .disclaimer {
    color: #791c58;
    font-size: 12px;
    text-align: left;
    background-color: #e6367d;
    padding: 3px;
    margin-left: -3px;
    a {
      color: #791c58;
    }
  }
  .signature {
    background-color: #99286c;
    p {
      text-align: left;
      font-size: 12px;
      color: #ff96fe;
      margin: 6px auto;
    }
    span {
      margin: 0 12px;
      &:first-of-type {
        margin-left: 0;
      }
    }
    a {
      margin: 0 12px;
      color: #ff96fe;
    }
  }
  @media screen and (max-width: $mediaQueryMid) {
    :global(.msg1._desktop) {
      display: none;
    }
    :global(.msg1._mobile) {
      display: block;
    }
    :global(._mobile-centered) {
      text-align: center;
    }
    .top {
      height: 115vw;
      background-size: 180vw;
      max-height: unset;
    }
    .intro {
      background-position: center;
      h2 {
        width: 70vw;
        height: 18vw;
      }
      p {
        padding: 0 12vw;
      }
      img {
        max-width: 120%;
        margin-left: -10%;
      }
    }
    .form {
      padding: 0 5vw;
      button img {
        width: 90%
      }
    }
    .signature {
      p {
        text-align: center;
        line-height: 1.8;
      }
    }
    .intro, .produtos, .form, .footer {
      background-size: 110%;
    }
  }
</style>